import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Thumb from './Thumbs';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Like/Dislike widget with clickable thumbs and vote counter
 * FIXME: Refactor SVG, Would be great to have one single svg with fill and rotate instead of 4
 */
export default function ThumbRate({
  children,
  likes,
  dislikes,
  onLike,
  onDislike,
  isDisabled,
  isLiked,
  isDisliked,
  className,
}) {
  return (
    <div className={cx('container', className)}>
      <span>{children}</span>
      <Thumb isPositive count={likes} onClick={onLike} isDisabled={isDisabled} isActive={isLiked} />
      <Thumb count={dislikes} onClick={onDislike} isDisabled={isDisabled} isActive={isDisliked} />
    </div>
  );
}

ThumbRate.propTypes = {
  children: PropTypes.node,
  likes: PropTypes.number,
  dislikes: PropTypes.number,
  onLike: PropTypes.func,
  onDislike: PropTypes.func,
  isLiked: PropTypes.bool,
  isDisliked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
};
